import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';
import { G_TABLE_CELL__inputs__field_kind } from './cells/G_TABLE_CELL__inputs__field_kind';
import { G_TABLE_CELL__inputs__field_role } from './cells/G_TABLE_CELL__inputs__field_role';
import { G_TABLE_CELL__inputs__node_type } from './cells/G_TABLE_CELL__inputs__node_type';
import { G_TABLE_CELL__store_family } from './cells/G_TABLE_CELL__store_family';

export interface PROPS<T extends FIELD__base> {
  fields: T[];
  /** Custom columns to appended at the end of standard columns */
  columns__additional?: ColumnDef<T, any>[];
}

export function HOOK_TABLE_LAYOUT__inputs__base<T extends FIELD__base>({ fields, columns__additional = [] }: PROPS<T>) {
  const helper_column = useMemo(() => createColumnHelper<T>(), []);

  const columns = useMemo(() => {
    const columns__base: ColumnDef<T, any>[] = [
      helper_column.accessor(row => row, {
        id: 'family',
        cell: info => <G_TABLE_CELL__store_family field={info.getValue() as any} />,
      }),
      helper_column.accessor(row => row, {
        id: 'field_kind',
        header: 'Kind',
        cell: info => <G_TABLE_CELL__inputs__field_kind field={info.getValue() as any} />,
      }),
      helper_column.accessor(row => row, {
        id: 'node_type',
        header: 'Node Type',
        cell: info => <G_TABLE_CELL__inputs__node_type field={info.getValue()} />,
      }),

      helper_column.accessor(row => row, { id: 'role', header: 'Role', cell: info => <G_TABLE_CELL__inputs__field_role field={info.getValue() as any} /> }),
    ];

    return [...columns__base, ...columns__additional];
  }, [fields, helper_column, columns__additional]);

  return columns;
}
